import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
//api
import { deleteContest } from 'api/concourse';
import { getAllContests } from 'api/pathForHook/concourse';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import Title from 'components/backoffice/texts/title';
import Button from 'components/backoffice/buttonCustom';
import SearchTable from 'components/backoffice/table/SearchTable';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import DropdownIcons from 'components/backoffice/dropDownIcons';

const Contests = () => {
  const userPermissions = usePermissions();
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const [listNames, setListNames] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [page, setPage] = useState(1);
  const [responseInfo, setResponseInfo] = useState({});
  const [timer, setTimer] = useState(null);
  const [selectedContest, setSelectedContest] = useState({});

  const colsContests = [t('name'), t('menuNumberUsers'), t('menuTableActions')];
  const { setTitle } = useOutletContext()

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListContests = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        name: inputValue,
        fields: 'id,name,user_library'
      }
      await fetchData(getAllContests(), payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTitle(t('contests'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListNames(results);
      setResponseInfo({ errors, totalPages, noResults });
    } else {
      setListNames(null);
      setResponseInfo({ errors });
    }
  }, [stateData])

  useEffect(() => {
    if (page > 1 && inputValue !== '') {
      setPage(1)
    }
  }, [inputValue])

  useEffect(() => {
    getListContests();
  }, [page, inputValue]);

  const onDelete = async () => {
    const { status } = await deleteContest(selectedContest.id);
    if (status === 204) {
      getListContests();
      setShowDeleteModal(false);
    }
  };

  const openModalDelete = (object) => {
    setShowDeleteModal(true);
    setSelectedContest(object);
  };

  const handleClear = () => {
    setInputValue('');
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, totalPages: responseInfo?.totalPages }));
  };

  return (
    <div className="d-lg-grid">
      <Title text={t('contests')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={5} xs={12} className="d-flex text-start">
          <SearchTable
            value={inputValue}
            handleSearch={setInputValue}
            handleClear={handleClear}
            handleKeyDown={true}
            placeholder={t('searchbyname')}
          />
        </Col>
        <Col md={7} xs={12} className="text-end mt-3 mt-md-0">
          {userPermissions.includes('concourse.__add') && (
            <Button
              variant="secondary"
              color={'primary'}
              onClick={() => navigate('/intranet/contests/create')}
            >
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsContests}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listNames &&
            listNames.map((listName) => {
              return (
                <tr key={listName.id}>
                  <td>{listName.name}</td>
                  <td>{listName.user_library.length}</td>
                  <td className="item-dropdown text-end">
                    <DropdownIcons
                      handleEdit={userPermissions.includes('concourse.__modify') && (() => navigate(`/intranet/contests/edit/${listName.id}`))}
                      handleDelete={userPermissions.includes('concourse.__delete') && (() => openModalDelete(listName))}
                      idItem={listName.id}
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      <DeleteModalCustom
        name={selectedContest?.nombre}
        openModal={showDeleteModal}
        setOpenModal={setShowDeleteModal}
        handleDelete={onDelete}
        deleteTitle={t('deletecontest')}
        beforeTitle={t('contests')}
      />
    </div>
  );
};

export default Contests;
